const state = {
  teams: [],
  currentTeam: null
}

export default state
